<template>
  <div class="my">
    <nav-bar
      fixed
      z-index="99"
      title="我的测评"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.go(-1)"
      right-text="个人中心"
      @click-right="$router.push('/user')"
    />
    <div class="my-box">
      <div class="my-box-top">
        <div class="my-box-top-left">
          <div class="my-box-top-left-choose">
            <div>状态</div>
            <div style="margin-left: 0.1rem">
              <NfDropdownMenu
                width="1.5rem"
                :value.sync="query.status"
                :options="orderStatusList"
              ></NfDropdownMenu>
            </div>
          </div>
        </div>
        <div class="my-box-top-right">
          <Icon name="plus"></Icon>
          <div @click="newEvaluation" class="my-box-top-right-btn">
            立即测评
          </div>
        </div>
      </div>
      <div class="my-box-list" ref="container">
        <template v-if="orderList.length > 0">
          <div>
            <template v-for="item in orderList">
              <nf-card class="my-box-list-item" :key="item.gameId">
                <div class="my-box-list-item-box" @click="goOrderDetail(item)">
                  <div class="my-box-list-item-box-item">
                    <div>
                      <div>
                        订单编号：
                        <span>{{ item.orderId || "暂无" }}</span>
                      </div>
                    </div>

                    <div>
                      订单状态：
                      <span v-if="item.status == 1">待测评</span>
                      <span v-else-if="item.status == 2">已测评</span>
                    </div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>
                      试卷编号：
                      <span>{{ item.pid || "暂无" }}</span>
                    </div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>订单价格：￥{{ item.payPrice }}</div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>
                      测评类型：{{ item.oneCateName }} -
                      {{ item.oneCateName }} - {{ item.cateName }}
                    </div>
                  </div>
                  <div class="my-box-list-item-box-item">
                    <div>开始时间：{{ formatDate(item.createTime) }}</div>
                  </div>
                </div>
              </nf-card>
            </template>

            <Loading v-if="orderList.length >= 10" :loading="loading"></Loading>
          </div>
        </template>
        <template v-else>
          <Empty>暂无数据</Empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, List, Cell, NavBar, Empty, List as VanList } from "vant";
import { getOrderList } from "@/api/evaluation";
import NfCard from "@/components/game-ui/NfCard.vue";
import NfButton from "@/components/game-ui/NfButton.vue";
import debounce from "lodash.debounce";
import NfDropdownMenu from "@/components/game-ui/NfDropdownMenu.vue";
import Loading from "@components/Loading";

export default {
  components: {
    Icon,
    NfCard,
    NfButton,
    List,
    Cell,
    NavBar,
    NfDropdownMenu,
    Empty,
    VanList,
    Loading,
  },
  data() {
    return {
      orderList: [],
      orderList: [],
      orderStatusList: [
        { text: "全部", value: null },
        { text: "待测评", value: 1 },
        { text: "已测评", value: 2 },
      ],
      page: {
        page: 1,
        limit: 10,
      },
      query: {
        status: null,
      },
      loading: false,
    };
  },
  mounted() {
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.onLoadList();
    });
  },
  methods: {
    getOrderList() {
      const data = {
        ...this.page,
        status: this.query.status !== null ? this.query.status : undefined,
      };
      if (this.loading) {
        return;
      }
      this.loading = true;
      getOrderList(data)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            if (this.page.page === 1) {
              this.orderList = res.data;
            } else {
              this.orderList.push(...res.data);
            }

            if (this.page.page > 1 && res.data.length == 0) {
              this.page.page--;
            }
          } else {
            if (this.page.page > 1) {
              this.page.page--;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          if (this.page.page > 1) {
            this.page.page--;
          }
        });
    },
    // 13位时间戳格式化
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + "/";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      const D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      const h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      const m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      const s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    onLoadList: debounce(function () {
      if (this.loading) return;
      this.page.page++;
      this.getOrderList();
    }, 500),
    // 查看详情
    goOrderDetail(item) {
      if (item.status == 2) {
        this.$router.push({
          path: "/evaluation/result",
          query: {
            orderId: item.orderId,
          },
        });
      } else {
        this.$router.push({
          path: "/evaluation/choose",
          query: {
            orderId: item.orderId,
          },
        });
      }
    },
    // 复制链接
    copyLink(item) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      if (item.password) {
        input.setAttribute(
          "value",
          `游戏链接：${item.gameUrl}  游戏密码：${item.password}`
        );
      } else {
        // input.setAttribute("value", item.gameUrl);
        input.setAttribute("value", `${item.gameUrl}`);
      }
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      this.$dialog.message("复制成功");
    },
    newEvaluation() {
      this.$router.push({
        path: "/evaluation",
      });
    },
  },
  watch: {
    query: {
      handler() {
        this.page.page = 1;
        this.getOrderList();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.my {
  background: rgb(255, 196, 0);
  // background: url(~@/assets/game/bg.png);

  &-box {
    width: 100%;
    height: 100%;

    border-top: solid 1px #333;
    background-color: #fff;
    padding: 0.2rem 0.3rem;
    font-size: 0.25rem;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-left {
        display: flex;

        &-choose {
          display: flex;
          align-items: center;
          margin-right: 0.1rem;
        }
      }

      &-right {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.35rem;
        color: rgb(255, 196, 0);
        font-weight: bold;
        font-family: STHeiti;

        &-btn {
          // font-size: 0.23rem;
        }
      }
    }

    &-list {
      width: 100%;

      &-item {
        margin: 0.1rem 0;

        &-box {
          &-item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(255, 196, 0) !important;
}
</style>
